// extracted by mini-css-extract-plugin
module.exports = {"Lang":"Lang--Lang--2iPn2bj","LangIcon":"Lang--LangIcon--1N8dzXy","langPop":"Lang--langPop--1q34SmY"};